import React from 'react';
import Typography from '#web-components/components/Typography';
import type { TypographyProps } from 'components/Typography/Typography';

export default function CitizenIcon(props: TypographyProps) {
  return (
    <Typography {...props}>👋</Typography>
  );
}
